import { Button } from '@graphcommerce/next-ui'
import { Container, Box } from '@mui/material'
import { blogTagsListQuery } from './BlogTagsList.gql'

type BlogTagsListProps = blogTagsListQuery

export function BlogTagsList(props: BlogTagsListProps) {
  const { blogTagsList } = props

  return (
    <Container
      maxWidth='md'
      sx={[
        (theme) => ({
          marginTop: theme.spacings.sm,
          marginBottom: theme.spacings.lg,
        }),
      ]}
    >
      <Box
        sx={[
          (theme) => ({
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: theme.spacings.xxs,
          }),
        ]}
      >
        {blogTagsList.map((blogTag) => (
          <Button
            key={blogTag.title}
            href={`/${blogTag.url}`}
            variant='pill'
            sx={[
              (theme) => ({
                backgroundColor: 'primary.main',
                color: 'primary.contrastText',
                padding: `5px ${theme.spacings.xs}`,

                '&:hover': {
                  backgroundColor: 'primary.dark',
                },
              }),
            ]}
          >
            {blogTag.title}
          </Button>
        ))}
      </Box>
    </Container>
  )
}
